import { SET_CONTEXT } from './context-action-type.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setContext = (context: any) => ({
	type: SET_CONTEXT,
	payload: context,
});
